import { render } from "./UserFormList.vue?vue&type=template&id=6160393f&ts=true"
import script from "./UserFormList.vue?vue&type=script&lang=ts"
export * from "./UserFormList.vue?vue&type=script&lang=ts"

import "./UserFormList.vue?vue&type=style&index=0&id=6160393f&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__